import styles from "./BiddingStrategy.module.scss";
import { Col, Row } from "reactstrap";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";

const BiddingStrategy = () => {
  const data = [
    {
      label: "Dynamic Bids – Down Only",
      content: `(Lowers your bid in real-time when it’s less likely to lead to a sale. It's useful for maximizing cost efficiency)`,
    },
    {
      label: "Dynamic Bids – Up and Down",
      content: `(Increases or decreases your bid in real-time based on the likelihood of a sale. It maximizes conversion potential but can lead to higher costs.)`,
    },
    {
      label: "Fixed Bids",
      content: `(Keeps your bids at a constant level without automatic adjustments. It provides more control over your spending but lacks adaptability to conversion likelihood.) `,
    },
    {
      label: "Adjust Bids by Placement",
      content: `(Allows you to set different bid multipliers for different placements (e.g., top-of-search, product pages). It helps optimize bids for specific locations where ads perform better.)`,
    },
  ];

  return (
    <div>
      <div className={styles["heading"]}>Bidding Strategy</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <div>Choose preferred bidding strategy</div>

          {data.map((item, index) => (
            <div key={index} className="d-flex gap-2 px-lg-3">
              <div className="mt-1">
                <Checkbox id={item.label} />
              </div>
              <div>
                <label htmlFor={item.label} className="fw-medium">
                  {item.label}
                </label>
                <div>{item.content}</div>
              </div>
            </div>
          ))}

          <div className={styles.bidStrategyContainer}>
            <Row className="g-0 align-items-center">
              <Col xs={5} xl={4} xxl={3} className="pe-2">Top of Search (First Page)</Col>
              <Col xs={2} xxl={1}>
                <div className="border border-secondary rounded px-2 py-1">
                  0%
                </div>
              </Col>
              <Col xs={5} className="ps-3">Adjust bid for top-of-search results</Col>
            </Row>
            <Row className="g-0 align-items-center">
              <Col xs={5} xl={4} xxl={3} className="pe-2">Product Pages</Col>
              <Col xs={2} xxl={1}>
                <div className="border border-secondary rounded px-2 py-1">
                  0%
                </div>
              </Col>
              <Col xs={5} className="ps-3">Adjust bid for product detail pages</Col>
            </Row>
            <Row className="g-0 align-items-center">
              <Col xs={5} xl={4} xxl={3} className="pe-2">Rest of Search</Col>
              <Col xs={2} xxl={1}>
                <div className="border border-secondary rounded px-2 py-1">
                  0%
                </div>
              </Col>
              <Col xs={5} className="ps-3">Adjust bid for general search results</Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiddingStrategy;